module.exports = __webpack_public_path__ + "font_malecharacter_son.3dbb99d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/font_malecharacter_son.png
// module id = nfwL
// module chunks = 0